import React from "react";
import { Heart, KeyRound } from "lucide-react";

const links = [
  { id: "home", label: "Home" },
  { id: "gallery", label: "Our Photos" },
  { id: "letters", label: "Love Letters" },
  { id: "journal", label: "Our Journal" },
  { id: "dreams", label: "Dream List" },
  { id: "fun", label: "Fun Zone" },
];

export default function Navbar({ names, onEditRiddles }) {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="main-navbar"
      className="sticky top-0 z-50 backdrop-blur-md bg-[#FDFBF7]/80 border-b border-[#EADEDA]"
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("home")}
          className="flex items-center gap-2 group"
        >
          <Heart className="w-5 h-5 text-[#D95F59] fill-[#D95F59] transition-transform group-hover:scale-125" />
          <span className="font-display text-xl tracking-tight">
            {names[0]} <span className="text-[#D95F59]">&</span> {names[1]}
          </span>
        </button>
        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="px-4 py-2 rounded-full text-sm text-[#756D6A] hover:text-[#2A2726] hover:bg-[#FFF5F5] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="edit-riddles-btn"
            onClick={onEditRiddles}
            title="Edit daily riddles"
            className="ml-1 w-9 h-9 rounded-full flex items-center justify-center text-[#D95F59] hover:bg-[#FFF5F5] transition-colors"
          >
            <KeyRound className="w-4 h-4" />
          </button>
        </div>
      </div>
    </nav>
  );
}
